import React, { useEffect } from 'react';
import { compose, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableRow
} from '@material-ui/core';
import withState from 'recompose/withState';
import CancelButton from '../atoms/CancelButton';
import ChangeButton from '../atoms/ChangeButton';
import RequiredButton from '../atoms/RequiredButton';
import ConfirmDialog from './ConfirmDialog';
import {
  UPDATE_GOCHI_KID_FLAG_SHOP_SUCCESS,
  updateGochiKidFlagShop,
  getShops
} from '../../actions/Shop';
import { sendLogin } from '../../auth/Auth';
import ProgressDialog from './ProgressDialog';

const styles = {
  titleModal: {
    fontWeight: 'bolder',
    margin: '0 0 20px 40px'
  },
  mainPaper: {
    minWidth: 400,
    padding: '0 20px'
  },
  dialogActionLeft: {
    justifyContent: 'flex-start'
  }
};

const enhance = compose(
  connect(
    null,
    dispatch => ({
      actions: bindActionCreators(
        {
          updateGochiKidFlagShop,
          getShops
        },
        dispatch
      )
    })
  ),
  withState('openProgress', 'updateOpenProgress', false),
  withState('openConfirm', 'updateOpenConfirm', false),
  withState('gochiKidFlag', 'setGochiKidFlag', props => {
    return props.oldGochiKidFlag;
  }),
  withState('gochiKidDonateFlag', 'setGochiKidDonateFlag', props => {
    return props.oldGochiKidDonateFlag;
  }),
  withState('gochiKidUserUseType', 'setGochiKidUserUseType', props => {
    return props.oldGochiKidUserUseType;
  }),
  withState('gochiKidQrFlag', 'setGochiKidQrFlag', props => {
    return props.oldGochiKidQrFlag;
  }),
  withState('joinGochiKidFlag', 'setJoinGochiKidFlag', 0),
  withState('loading', 'setLoading', false),
  withState('message', 'setMessage', ''),
  withState('errorMessage', 'setErrorMessage', ''),
  withHandlers({
    checkSession: props => data => {
      if (
        data.error === true &&
        typeof data.payload !== 'undefined' &&
        data.payload.status === 403
      ) {
        sendLogin(props);
      }
      return data;
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    openChange,
    updateOpenChange,
    openConfirm,
    updateOpenConfirm,
    openProgress,
    updateOpenProgress,
    gochiKidFlag,
    setGochiKidFlag,
    gochiKidDonateFlag,
    setGochiKidDonateFlag,
    gochiKidUserUseType,
    setGochiKidUserUseType,
    gochiKidQrFlag,
    setGochiKidQrFlag,
    oldGochiKidFlag,
    oldGochiKidDonateFlag,
    oldGochiKidUserUseType,
    oldGochiKidQrFlag,
    loading,
    setLoading,
    message,
    setMessage,
    errorMessage,
    setErrorMessage,
    shopId,
    checkSession,
    searchKey,
    joinGochiKidFlag,
    setJoinGochiKidFlag
  }) => {
    useEffect(() => {
      if (openChange) {
        setGochiKidFlag(oldGochiKidFlag);
        setGochiKidDonateFlag(oldGochiKidDonateFlag);
        setGochiKidUserUseType(oldGochiKidUserUseType);
        setGochiKidQrFlag(oldGochiKidQrFlag);
        if (oldGochiKidFlag === 0 && oldGochiKidQrFlag === 0) {
          setJoinGochiKidFlag(0);
        } else if (oldGochiKidFlag === 1 && oldGochiKidQrFlag === 1) {
          setJoinGochiKidFlag(1);
        } else if (oldGochiKidFlag === 1 && oldGochiKidQrFlag === 0) {
          setJoinGochiKidFlag(2);
        }
      }
    }, [openChange]);

    function cancelAction() {
      updateOpenChange(false);
    }

    function openConfirmAction() {
      updateOpenChange(false);
      updateOpenConfirm(true);
    }

    async function changeAction() {
      setLoading(true);
      updateOpenProgress(true);
      updateOpenConfirm(false);
      const response = await actions
        .updateGochiKidFlagShop(shopId, {
          gochiKidDonateFlag,
          gochiKidFlag,
          gochiKidUserUseType,
          gochiKidQrFlag
        })
        .then(data => checkSession(data));
      if (response.type === UPDATE_GOCHI_KID_FLAG_SHOP_SUCCESS) {
        await actions.getShops(searchKey).then(data => checkSession(data));
        setLoading(false);
        setMessage('更新しました。');
      } else {
        setErrorMessage('エラーが発生しました！');
        setLoading(false);
        updateOpenProgress(false);
      }
    }

    function handleChangeJoinGochiKidFlag(value) {
      if (value === 0) {
        setGochiKidFlag(0);
        setGochiKidQrFlag(0);
      } else if (value === 1) {
        setGochiKidFlag(1);
        setGochiKidQrFlag(1);
      } else if (value === 2) {
        setGochiKidFlag(1);
        setGochiKidQrFlag(0);
      }
      setJoinGochiKidFlag(value);
    }

    function progressOkAction() {
      updateOpenProgress(false);
      setMessage('');
    }

    return (
      <>
        <Dialog
          open={openChange}
          onClose={cancelAction}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={classes.dialogChange}
        >
          <DialogContent>
            <Typography component="p" className={classes.titleModal}>
              こどもごちめし参加設定
            </Typography>
            <Paper className={classes.mainPaper} elevation={1}>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <RequiredButton />
                    </TableCell>
                    <TableCell>
                      こどもごちめし参加*
                      <RadioGroup
                        value={joinGochiKidFlag}
                        onChange={e => {
                          const allowed = parseInt(e.target.value, 10);
                          handleChangeJoinGochiKidFlag(allowed);
                        }}
                        className={classes.radioGroup}
                      >
                        <FormControlLabel
                          value={0}
                          control={<Radio color="primary" />}
                          label={
                            <Typography style={{ fontWeight: 'bolder' }}>
                              参加しない
                            </Typography>
                          }
                        />
                        <FormControlLabel
                          value={1}
                          control={<Radio color="primary" />}
                          label={
                            <Typography style={{ fontWeight: 'bolder' }}>
                              参加する(カード型会員証対応あり)
                            </Typography>
                          }
                        />
                        <FormControlLabel
                          value={2}
                          control={<Radio color="primary" />}
                          label={
                            <Typography style={{ fontWeight: 'bolder' }}>
                              参加する(カード型会員証対応なし)
                            </Typography>
                          }
                        />
                      </RadioGroup>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <RequiredButton />
                    </TableCell>
                    <TableCell>
                      寄付可能設定*
                      <RadioGroup
                        value={gochiKidDonateFlag}
                        onChange={e => {
                          const allowed = parseInt(e.target.value, 10);
                          setGochiKidDonateFlag(allowed);
                        }}
                        className={classes.radioGroup}
                      >
                        <FormControlLabel
                          value={1}
                          control={<Radio color="primary" />}
                          label={
                            <Typography style={{ fontWeight: 'bolder' }}>
                              寄付可能
                            </Typography>
                          }
                        />
                        <FormControlLabel
                          value={0}
                          control={<Radio color="primary" />}
                          label={
                            <Typography style={{ fontWeight: 'bolder' }}>
                              寄付不可能
                            </Typography>
                          }
                        />
                      </RadioGroup>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <RequiredButton />
                    </TableCell>
                    <TableCell>
                      こどもごちめし利用対象設定*
                      <RadioGroup
                        value={gochiKidUserUseType}
                        onChange={e => {
                          const allowed = parseInt(e.target.value, 10);
                          setGochiKidUserUseType(allowed);
                        }}
                        className={classes.radioGroup}
                      >
                        <FormControlLabel
                          value={1}
                          control={<Radio color="primary" />}
                          label={
                            <Typography style={{ fontWeight: 'bolder' }}>
                              全ての子ども
                            </Typography>
                          }
                        />
                        <FormControlLabel
                          value={2}
                          control={<Radio color="primary" />}
                          label={
                            <Typography style={{ fontWeight: 'bolder' }}>
                              めぐまれない子どものみ
                            </Typography>
                          }
                        />
                      </RadioGroup>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Paper>
          </DialogContent>
          <DialogActions className={classes.dialogActionLeft}>
            <CancelButton color="primary" onClickAction={cancelAction} />
            <ChangeButton onClickAction={openConfirmAction} />
          </DialogActions>
        </Dialog>
        <ConfirmDialog
          openConfirm={openConfirm}
          updateOpenConfirm={updateOpenConfirm}
          message="設定を更新します。よろしいでしょうか。"
          okAction={changeAction}
        />
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={message}
        />
        <ProgressDialog
          openProgress={errorMessage !== ''}
          progressOkAction={() => setErrorMessage('')}
          loading={false}
          resultMessage={errorMessage}
        />
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
